export const ga_mixin = {
    methods: {
        google_analitics_ids: function(){

                setTimeout(()=>{
                    $('button:not([id])').attr('id',this.$store.state.active_view + '--button')
                    $('a:not([id])').attr('id',this.$store.state.active_view + '--link')
                    $('form:not([id])').attr('id',this.$store.state.active_view + '--form')

                    $('.social-share--facebook').attr('id','social-share--facebook')
                    $('.social-share--twitter').attr('id','social-share--twitter')
                },10)

        },
        google_analitics(){
            window.gtag('config', ga_id, {
                'page_title' : this.$store.state.active_view,
                'page_location': location.href,
                'page_path': '#'+this.$store.state.active_view
            });
        },
        google_analitics_event(){

            setTimeout(()=>{
                $('button, a:not(#twitter-link),.social-share__inner').off('click.jq')
                $('button, a:not(#twitter-link),.social-share__inner').on('click.jq',()=>{
                    this.send_gtag('click',$(this).attr('id'),'')
                })

                $('[data-sweeps_prize_pools], [data-grand_prize_pools]').off('click.jq')
                $('[data-sweeps_prize_pools], [data-grand_prize_pools]').on('click.jq',()=>{
                    this.send_gtag('select prize pool',$(this).attr('id'),'')
                })
            },20)

        },
        send_gtag(action,category,label){
            window.gtag('event', action, {
                'event_category' : category,
                'event_label' : label
            });
        }
    },
    created(){

    },
    mounted(){

    }
}